import SEO from './SEO';
import { buildUrl } from '../../config/seo';

const AboutUsSEO = () => {
  return (
    <SEO
      title="About Us - The Web Dev Interview"
      description="Learn about The Web Dev Interview platform. We provide curated interview questions, mock interview services, and resources to help developers prepare confidently for their next job."
      keywords="about us, web developer resources, interview preparation platform, developer interview questions, coding interview help"
      url={buildUrl('/about')}
      type="website"
    />
  );
};

export default AboutUsSEO;